"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const merlin_logo_1 = require("@travelnest/merlin.logo");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const FTUX_House_svg_1 = __importDefault(require("./FTUX_House.svg"));
const green_blob_svg_1 = __importDefault(require("./green-blob.svg"));
const backgroundStyles = {
    'empty': '',
    'house': `
		opacity: 0.25;
		background-image: url(${FTUX_House_svg_1.default});
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: bottom center;
	`,
    'green-blob': `
		opacity: 0.15;
		background-image: url(${green_blob_svg_1.default});
		background-size: 33rem auto;
		background-repeat: no-repeat;
		background-position: bottom -17rem right -10rem;
	`,
};
const PageBody = styled_1.default.div `
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	align-items: center;
	justify-content: center;

	@media only screen and (min-width: 760px) {
		flex-direction: row;
	}
`;
const PageWrapper = styled_1.default.div `
	padding: 0 ${merlin_theme_1.default.layout.spacing.standard};
	flex-grow: 1;
	position: relative;
	width: 100%;
	max-width: calc(calc(${merlin_theme_1.default.layout.container.maxWidth} + ${merlin_theme_1.default.layout.spacing.smaller}) / 2);
	border-radius: ${merlin_theme_1.default.layout.radius.squared};
	box-shadow: 0 1px 5px 0 ${merlin_theme_1.default.colours.shadow.default};

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: ${merlin_theme_1.default.layout.radius.squared};
	}

	&::before {
		z-index: -1;
		${({ bg }) => bg};
	}

	&::after {
		z-index: -2;
		background-color: ${merlin_theme_1.default.colours.background.lighter};
	}

	@media only screen and (min-width: 760px) {
		min-height: 700px;
	}
`;
const PageHeaderContent = styled_1.default.div `
	width: 100%;
	max-width: ${merlin_theme_1.default.layout.container.maxWidth};
	margin: auto;
	padding: ${merlin_theme_1.default.layout.spacing.smaller} 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 80px;
	box-sizing: border-box;
`;
const BottomWrapper = styled_1.default.div `
	width: calc(100% + calc(${merlin_theme_1.default.layout.spacing.large} * 2));
	max-width: ${merlin_theme_1.default.layout.container.maxWidth};
	margin: 0 -${merlin_theme_1.default.layout.spacing.large};
	border-top: 1px solid ${merlin_theme_1.default.palette.greyscale.light};
`;
const Page = styled_1.default.div `
	display: block;
	max-width: ${merlin_theme_1.default.layout.container.maxWidth};
	margin: auto;

	@media only screen and (min-width: 760px) {
		display: flex;
		justify-content: space-between;
		padding: 30px;
	}
`;
const PageContent = styled_1.default.div `
	flex-grow: 1;
	display: flex;
	flex-direction: column;

	.page-content__container {
		width: 100%;
	}

	padding-bottom: ${merlin_theme_1.default.layout.spacing.large};

`;
const FeaturedContainer = (props) => {
    const { children, headerBottomContent, rightHandContent, logoUrl, backgroundImage, fullLogo, hideHeader } = props;
    return React.createElement(PageBody, null,
        React.createElement(PageWrapper, { bg: backgroundStyles[backgroundImage || 'house'] },
            !hideHeader && React.createElement("div", { id: "header", style: { position: 'sticky', top: '0', zIndex: 2, backgroundColor: 'white' } },
                React.createElement(PageHeaderContent, null,
                    React.createElement(merlin_logo_1.Logo, Object.assign({}, logoUrl ? { url: logoUrl } : { disabled: true, fullLogo: !!fullLogo })),
                    rightHandContent ? rightHandContent : null),
                React.createElement(BottomWrapper, null, headerBottomContent ? headerBottomContent : null)),
            React.createElement(Page, null,
                React.createElement(PageContent, null, children))));
};
exports.FeaturedContainer = FeaturedContainer;
//# sourceMappingURL=FeaturedContainer.js.map